import { Navigate } from "react-router-dom";
import { WEB_ROUTES } from "../../constants";
import { SocketProvider } from "../../Context/SocketContext";
import { getToken } from "../../Data/services/localStorageService";

function ProtectedRoute({ children }) {
  const token = getToken();
  return token ? (
    <SocketProvider>{children}</SocketProvider>
  ) : (
    <Navigate to={WEB_ROUTES.ACCOUNT} replace />
  );
}

export default ProtectedRoute;
